import Page from "../components/Page";
import AboutIntro from "../components/AboutIntro";
import Recognition from "../components/Recognition";

export default function About() {
	return (
		<Page title="About">
			<AboutIntro />
			<Recognition />
		</Page>
	);
}
